import React, { useState, useRef, useEffect } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import './commonDateRange.css';

const CommonDateRange = ({
  name = "Date Range",
  actionWidthLeft = false,
  initialStartDate,
  initialEndDate,
  onApply,
  datePrefield = true,
  isDefaultToday = false
}) => {
  const [range, setRange] = useState({
    startDate: initialStartDate || moment().subtract(isDefaultToday ? 0 : 32, 'days'),
    endDate: initialEndDate || moment(),
  });

  const [selectedLabel, setSelectedLabel] = useState('');

  const pickerRef = useRef(null);

  const getCurrentFY = () => {
    const now = moment();
    const start =
      now.month() >= 3
        ? moment().month(3).startOf('month')
        : moment().subtract(1, 'year').month(3).startOf('month');

    const end = start.clone().add(1, 'year').subtract(1, 'day');
    return [start, end];
  };

  const getPreviousFY = () => {
    const [currentFYStart] = getCurrentFY();
    const start = currentFYStart.clone().subtract(1, 'year');
    const end = currentFYStart.clone().subtract(1, 'day');
    return [start, end];
  };

  const ranges = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
    'Current FY': getCurrentFY(),
    'Previous FY': getPreviousFY(),
  };

  // Function to detect which predefined range matches the current dates
  const detectRangeLabel = (start, end) => {
    for (const [label, [rangeStart, rangeEnd]] of Object.entries(ranges)) {
      if (
        start.format('YYYY-MM-DD') === rangeStart.format('YYYY-MM-DD') &&
        end.format('YYYY-MM-DD') === rangeEnd.format('YYYY-MM-DD')
      ) {
        return label;
      }
    }
    return null; // Custom range
  };

  useEffect(() => {
    const newRange = {
      startDate: initialStartDate || moment().subtract(isDefaultToday ? 0 : 32, 'days'),
      endDate: initialEndDate || moment(),
    };
    setRange(newRange);

    // Detect and set the label
    const label = detectRangeLabel(newRange.startDate, newRange.endDate);
    setSelectedLabel(label || '');
  }, [initialStartDate, initialEndDate]);

  const handleEvent = (event, picker) => {
    const newRange = {
      startDate: picker.startDate,
      endDate: picker.endDate,
    };

    setRange(newRange);

    // Detect which range was selected
    const label = detectRangeLabel(picker.startDate, picker.endDate);
    setSelectedLabel(label || '');

    picker.hide();

    if (onApply) {
      onApply(newRange);
    }
  };

  // Display logic for input field
  const getDisplayValue = () => {
    if (!datePrefield && !selectedLabel) {
      return '';
    }

    if (selectedLabel) {
      return `: ${selectedLabel}`;
    }

    // Custom range - show dates
    return `: Custom` // `${range.startDate.format('MMMM D, YYYY')} - ${range.endDate.format('MMMM D, YYYY')}`;
  };

  return (
    <DateRangePicker
      initialSettings={{
        startDate: range?.startDate?.toDate(),
        endDate: range?.endDate?.toDate(),
        ranges,
        locale: { format: 'MMMM D, YYYY' },
        showDropdowns: true,
        alwaysShowCalendars: true,
        showCustomRangeLabel: true,
        parentEl: actionWidthLeft ? "#datePickerContainer" : "",
        opens: actionWidthLeft ? "left" : "right",
      }}
      onApply={handleEvent}
      ref={pickerRef}
    >
      <div id="datePickerContainer" className="input-group anvCustom_floatInput form-floating ">
        <input
          type="text"
          label={name}
          className="form-control"
          placeholder={name}
          value={`${name} ${getDisplayValue()}`}
          readOnly
        />
      </div>
    </DateRangePicker>
  );
};

export default CommonDateRange;